.loader-container
    display: flex
    justify-content: center
    align-items: center
    padding-top: 10px
    height: 40px


.loader-square
    width: 12px
    height: 12px
    background-color: #95a5a6
    margin: 0 5px
    border-radius: 4px
    animation: subtle-bounce 1.4s infinite ease-in-out
    transform: scale(0.9)


@keyframes subtle-bounce
    0%, 80%, 100%
        transform: translateY(0) scale(0.9)
        opacity: 0.5

    40%
        transform: translateY(-3px) scale(1.0)
        opacity: 0.8

.loader-square:nth-child(1)
    animation-delay: 0s

.loader-square:nth-child(2)
    animation-delay: 0.2s

.loader-square:nth-child(3)
    animation-delay: 0.4s
